<header class="page-header">
    <div class="page-header__left">
        <p class="page-header__title">
            {{ breadcrumbData()[0].label | translate }}
        </p>
        <div class="page-header__breadcrumb" *ngIf="breadcrumbData().length > 1">
            @for (item of breadcrumbData(); let index = $index; track item) {

            <span> <a [routerLink]="item.route" routerLinkActive #rla="routerLinkActive"
                    [ngClass]="{'last-anchor': index === breadcrumbData().length - 1}"> {{ item.label | translate }}</a>
            </span>

            <span *ngIf="breadcrumbData().length !== index + 1">
                &nbsp;<i class="fa-solid fa-caret-right"></i>&nbsp;
            </span>
            }
        </div>
    </div>
    <div class="page-header__right">
        @if ( fullUserRoleVerticle.includes('block-manager')){
        <div class="send-report-button" *ngIf="sendReportBtnClick()" (click)="sendReportBtnClick()?.()">
            <div class="send-report-button__text">
                {{ 'sendReport' | translate }}</div>
        </div>
        }

        <button class="page-header__button" *ngIf="exportButtonClick()" (click)="exportButtonClick()?.()">
            <span><img ngSrc="../../assets/img/export.svg" alt="" [fill]="true"></span>
            {{ 'export' | translate }}
        </button>
        <!-- <button class="page-header__button" *ngIf="refreshButtonClick()" (click)="refreshButtonClick()?.()">
            <span><img ngSrc="../../assets/img/refresh.svg" alt="" [fill]="true"></span>
            {{ 'refresh' | translate }}
        </button> -->
    </div>
</header>